/**
 * Deutsche Sprachdatei - zugleich die Referenz für alle anderen Sprachen.
 *
 * Grundsätze aus 00_product_overview.md und 02_navigation_ux_tutorial_i18n.md:
 * keine technischen Begriffe im normalen Benutzerinterface, Fehlermeldungen in
 * Alltagssprache, alle sichtbaren Texte aus Sprachdateien.
 */
import { deCampaigns } from './de.campaigns';
import { deDialer } from './de.dialer';
import { dePlatform } from './de.platform';
import { deUi } from './de.ui';
import { deTelephony } from './de.telephony';

export const de = {
  ...deCampaigns,
  ...deUi,
  ...deDialer,
  ...dePlatform,
  ...deTelephony,
  'app.name': 'Autodialer',
  'app.loading': 'Einen Moment …',

  'action.login': 'Anmelden',
  'action.logout': 'Abmelden',
  'action.save': 'Speichern',
  'action.cancel': 'Abbrechen',
  'action.back': 'Zurück',
  'action.create': 'Anlegen',
  'action.showPassword': 'Passwort anzeigen',
  'action.hidePassword': 'Passwort verbergen',

  'login.title': 'Anmelden',
  'login.identifier': 'E-Mail-Adresse oder Benutzername',
  'login.identifierHint': 'Als Kundenkonto melden Sie sich mit Ihrer E-Mail-Adresse an, als Caller mit Ihrem Benutzernamen.',
  'login.password': 'Passwort',
  'login.forgotPassword': 'Passwort vergessen?',
  'login.noAccount': 'Noch kein Konto? Jetzt registrieren',
  'login.platformTitle': 'Verwaltung',
  'login.email': 'E-Mail-Adresse',

  'register.title': 'Konto anlegen',
  'register.email': 'E-Mail-Adresse',
  'register.password': 'Passwort',
  'register.passwordConfirmation': 'Passwort wiederholen',
  'register.submit': 'Konto anlegen',
  'register.haveAccount': 'Sie haben bereits ein Konto? Anmelden',
  'register.successTitle': 'Willkommen',
  'register.successText': 'Ihr Konto ist angelegt. Sie können sich jetzt anmelden.',
  'register.customerNumber': 'Ihre Kundennummer',
  'register.customerNumberHint': 'Diese Nummer brauchen Sie, wenn Sie den Support kontaktieren.',

  'forgot.title': 'Passwort vergessen',
  'forgot.text': 'Geben Sie Ihre E-Mail-Adresse ein. Wenn ein Konto dazu besteht, senden wir Ihnen einen Link zum Festlegen eines neuen Passworts.',
  'forgot.submit': 'Link anfordern',
  'forgot.done': 'Wenn zu dieser Adresse ein Konto besteht, ist die E-Mail unterwegs. Bitte schauen Sie in Ihr Postfach.',
  'forgot.callerHint': 'Callerzugänge haben kein Passwort-vergessen. Bitte wenden Sie sich an Ihren Administrator.',

  'reset.title': 'Neues Passwort festlegen',
  'reset.password': 'Neues Passwort',
  'reset.submit': 'Passwort speichern',
  'reset.done': 'Ihr Passwort ist gespeichert. Sie können sich jetzt anmelden.',

  'home.greeting': 'Willkommen',
  'home.role.owner': 'Kontoinhaber',
  'home.role.admin': 'Administrator',
  'home.role.caller': 'Caller',
  'home.customerNumber': 'Kundennummer',
  'home.nextSteps': 'Die Bereiche für Kampagnen, Datensätze und Telefonie entstehen in den nächsten Schritten.',

  'nav.home': 'Start',
  'nav.callers': 'Caller',
  'nav.account': 'Einstellungen',

  'callers.title': 'Caller',
  'callers.intro': 'Hier legen Sie die Zugänge für Ihre Caller an.',
  'callers.username': 'Benutzername',
  'callers.password': 'Passwort',
  'callers.add': 'Caller anlegen',
  'callers.empty': 'Es gibt noch keine Caller.',
  'callers.isAdmin': 'Administrator',
  'callers.makeAdmin': 'Zum Administrator machen',
  'callers.revokeAdmin': 'Administratorrechte entziehen',
  'callers.deactivate': 'Zugang deaktivieren',
  'callers.activate': 'Zugang freigeben',
  'callers.newPassword': 'Neues Passwort setzen',
  'callers.newPasswordSaved': 'Das neue Passwort ist gespeichert.',
  'callers.inactive': 'Deaktiviert',
  'callers.you': 'Sie',

  'account.title': 'Einstellungen',
  'account.name': 'Firmen- oder Kontoname',
  'account.nameSaved': 'Gespeichert.',
  'account.email': 'E-Mail-Adresse',
  'account.customerNumber': 'Kundennummer',
  'account.balance': 'Guthaben',
  'account.pricePerMinute': 'Preis pro Gesprächsminute',
  'account.changePassword': 'Passwort ändern',
  'account.currentPassword': 'Aktuelles Passwort',
  'account.newPassword': 'Neues Passwort',
  'account.passwordSaved': 'Ihr Passwort ist geändert.',
  'account.language': 'Sprache',
  'account.delete': 'Konto löschen',
  'account.deleteWarning':
    'Damit wird Ihr Konto geschlossen. Sie und Ihre Caller können sich danach nicht mehr anmelden. Dieser Schritt lässt sich nicht rückgängig machen.',
  'account.deleteConfirm': 'Ja, Konto endgültig schließen',
  'account.deletePassword': 'Bitte geben Sie zur Bestätigung Ihr Passwort ein.',

  'session.endedTitle': 'Sie wurden abgemeldet',
  'session.ended.replaced': 'Sie haben sich in einem anderen Fenster angemeldet. Aus Sicherheitsgründen ist immer nur eine Anmeldung gleichzeitig möglich.',
  'session.ended.idle': 'Sie waren eine Stunde lang nicht aktiv. Bitte melden Sie sich erneut an.',
  'session.ended.suspended': 'Konto gesperrt. Bitte wenden Sie sich an den Support.',
  'session.ended.deleted': 'Dieses Konto ist geschlossen.',
  'session.ended.password_changed': 'Ihr Passwort wurde geändert. Bitte melden Sie sich erneut an.',
  'session.ended.logout': 'Bitte melden Sie sich an.',

  'error.auth.invalid_credentials': 'Anmeldedaten stimmen nicht. Bitte noch einmal versuchen.',
  'error.auth.too_many_attempts': 'Zu viele Versuche. Bitte warten Sie zwei Minuten und versuchen Sie es dann erneut.',
  'error.auth.account_suspended': 'Konto gesperrt. Bitte wenden Sie sich an den Support.',
  'error.auth.user_inactive': 'Dieser Zugang ist deaktiviert. Bitte wenden Sie sich an Ihren Administrator.',
  'error.auth.required': 'Bitte melden Sie sich an.',
  'error.auth.admin_required': 'Für diesen Bereich benötigen Sie Administratorrechte.',
  'error.registration.email_taken': 'Für diese E-Mail-Adresse besteht bereits ein Konto.',
  'error.registration.invalid_email': 'Bitte eine gültige E-Mail-Adresse eingeben.',
  'error.registration.password_mismatch': 'Die beiden Passwörter stimmen nicht überein.',
  'error.registration.password_required': 'Bitte ein Passwort eingeben.',
  'error.caller.username_taken': 'Dieser Benutzername ist bereits vergeben. Bitte einen anderen wählen.',
  'error.caller.invalid_username': 'Der Benutzername darf nur Buchstaben, Ziffern, Punkt, Bindestrich und Unterstrich enthalten.',
  'error.caller.password_required': 'Bitte ein Passwort vergeben.',
  'error.caller.not_found': 'Dieser Zugang wurde nicht gefunden.',
  'error.caller.owner_keeps_admin': 'Dem Inhaber des Kontos können die Administratorrechte nicht entzogen werden.',
  'error.caller.owner_stays_active': 'Der Zugang des Kontoinhabers kann nicht deaktiviert werden.',
  'error.password.current_wrong': 'Das aktuelle Passwort stimmt nicht.',
  'error.password.reset_token_invalid': 'Dieser Link ist nicht mehr gültig. Bitte fordern Sie einen neuen an.',
  'error.account.only_owner_may_delete': 'Nur der Inhaber des Kontos kann das Konto löschen.',
  'error.account.confirmation_required': 'Bitte bestätigen Sie die Löschung ausdrücklich.',
  'error.request.invalid': 'Bitte prüfen Sie Ihre Eingaben.',
  'error.unknown': 'Das hat leider nicht geklappt. Bitte versuchen Sie es noch einmal.',
  'error.offline': 'Die Anwendung ist gerade nicht erreichbar. Bitte später erneut versuchen.',
} as const;

export type TranslationKey = keyof typeof de;
export type Dictionary = Record<TranslationKey, string>;
